export default "__VITE_ASSET__gH3DMwzs__"